<template>
  <div>
    <!-- <pre>{{userInfo}}</pre> -->
   <!-- <pre> {{selected}}</pre> -->
    <div
      class="flex flex-wrap mb-4"
      v-if="selected.length != 0"
    >
    <div  v-for="(selected, index) in selected"
      :key="index">
    
      <div class="text-center mr-1">
        <div class="selected-names">
          <!-- <p>AYsgahbjdja</p> -->
          <!-- <p> -->
            <!-- {{selected.first_name.length}} -->

          <!--   <span v-if="selected.first_name.length">{{ selected.first_name[0] }}</span> 
            <span v-if="selected.last_name.length"> {{ selected.last_name[0] }}</span>
             </p> -->

             <img v-if="selected.picture" class="person-img rounded-full shadow-md block" :src="selected.picture" />
              <img v-else
                class="person-img rounded-full shadow-md block"
                src="@/assets/images/pages/user-circle-solid.svg"
              />

          <span class="close"
          @click="removeSelected(selected.id,index)"
          >&times;</span>
        </div>
        <p class="name-selected">
          {{ selected.first_name }} {{ selected.last_name }}
        </p>
      </div>
    </div>
    </div>
    <vs-table
      multiple
      v-model="selected"
      :data="userInfo"
      class="removeCheckbox cstm_vuexy_table"
    >
      <template slot="thead">
        <vs-th style="width: 80px;"> Image </vs-th>
        <vs-th> Name </vs-th>
        <vs-th> Email </vs-th>
        <!-- <vs-th> Subject </vs-th> -->
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].picture">
            <img
              class="imgpic"
              v-if="data[indextr].picture"
              :src="data[indextr].picture"
              style="height: 40px; width: 40px; object-fit: contain;"
            />
            <img
              class="imgpic"
              v-else
              src="http://scoolio-dev.track-progress.com/img/user-circle-solid.c3580913.svg"
              style="height: 40px; width: 40px; object-fit: contain;"
            />
          </vs-td>
          <vs-td :data="data[indextr].first_name">
            {{ data[indextr].first_name }} {{ data[indextr].last_name }}
          </vs-td>
          <vs-td :data="data[indextr].user_active_email.email">
            {{ data[indextr].user_active_email.email }}
          </vs-td>

          <!-- <vs-td> Null </vs-td> -->
        </vs-tr>
      </template>
    </vs-table>

    <vs-button class="block ml-auto mt-4" @click="shareModule()"
      >Share
    </vs-button>

    <!-- <pre>{{ selected }}</pre> -->
  </div>
</template>
<script>
import { fetchUser, assignmentShare } from '@/api/assignment-question'

import { courseShare } from '@/api/course-builderapi.js'

import { questionShare } from '@/api/question-bank'
export default {
  name: 'userInfoModal',
  props: {
    courseId: {
      default: null
    },
    assignment_id: {
      default: null
    },
    question_id: {
      default: null
    },
    Modaltype: {
      required: true,
      type: String
    },
    sharedUserList: {
      required: true,
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      selected: [],
      userInfo: [],
      selectedUserId: []
    }
  },
  created () {
    this.fetchUserList()
  },
  watch:{
    selected:{
      deep:true,
      handler () {
        
        const userId = this.selected.map(ele => {
          return ele.id
        })

        

        
        // this.userInfo = this.userInfo.map(ele => {

        // })
        this.userInfo = this.userInfo.filter(function (item) {
          return !userId.includes(item.id)
        })
        
      }
    }
  },
  //   mounted () {
  //     
  //     this.fetchUserList()
  //   },
  methods: {
    async fetchUserList () {
      try {
        this.$vs.loading({
          text: 'Please Wait While Fetching Users ...'
        })

        const customerId = this.$store.getters.customerId
        const responseUser = await fetchUser(customerId)
        // 
        this.userInfo = responseUser.data.data.users_list
        
        // const userId = this.sharedUserList.map((ele) => {
        //   return ele.to_user_id
        // })
        this.selectingAlreadySharedUser()
        // this.userInfo = this.userInfo.map(ele=>{
        //   return !ele.to_user_id
        // })
      } catch (error) {
        
      } finally {
        this.$vs.loading.close()
      }
    },
    selectingAlreadySharedUser () {
     
      // 
      const userId = this.sharedUserList.map((ele) => {
        return ele.to_user_id
      })

      this.selected = this.userInfo.filter(function (item) {
        return userId.includes(item.id)
      })

      this.userInfo = this.userInfo.filter(function (item) {
        return !userId.includes(item.id)
      })
    },
    shareModule () {
      
      
      this.selectedUserId = this.selected.map((eachUserId) => {
        return eachUserId.id
      })
      

      if (this.Modaltype === 'Course') {
        
        this.savingCourseShareModule()
      } else if (this.Modaltype === 'QuestionBank') {
        
        this.savingQuestionShareModule()
      } else {
        
        this.savingAssignmentShareModule()
      }
      //   courseShare
    },
    async savingCourseShareModule () {
      const customer_id = this.$store.getters.customerId
      try {
        this.$vs.loading({
          text: 'Please Wait While Sharing ...'
        })
        const payload = {
          course_id: this.courseId,
          to_user_ids: this.selectedUserId
        }
        const data = await courseShare(customer_id, payload)

        if (data) {
          this.showSuccessMessage(
            'Success',
            'Shared with user successfully',
            'success'
          )
        }
        this.$emit('updateUserId', this.selectedUserId)
      } catch (error) {
        
        this.showSuccessMessage('Danger', 'Something Went Wrong', 'danger')
      } finally {
        this.$vs.loading.close()
      }
    },
    async savingAssignmentShareModule () {
      const customer_id = this.$store.getters.customerId
      try {
        this.$vs.loading({
          text: 'Please Wait While Sharing ...'
        })
        const payload = {
          assignment_id: this.assignment_id,
          to_user_ids: this.selectedUserId
        }
        const data = await assignmentShare(customer_id, payload)
        if (data) {
          this.showSuccessMessage(
            'Success',
            'Shared with user successfully',
            'success'
          )
          this.$emit('updateUserId', this.selectedUserId)
        }
      } catch (error) {
        
        this.showSuccessMessage('Danger', 'Something Went Wrong', 'danger')
      } finally {
        this.$vs.loading.close()
      }
    },
    async savingQuestionShareModule () {
      const customer_id = this.$store.getters.customerId
      try {
        this.$vs.loading({
          text: 'Please Wait While Sharing ...'
        })
        const payload = {
          question_bank_id: this.question_id,
          to_user_ids: this.selectedUserId
        }
        const data = await questionShare(customer_id, payload)
        if (data) {
          this.showSuccessMessage(
            'Success',
            'Shared with user successfully',
            'success'
          )
          this.$emit('updateUserId', this.selectedUserId)
        }
      } catch (error) {
        
        this.showSuccessMessage('Danger', 'Something Went Wrong', 'danger')
      } finally {
        this.$vs.loading.close()
      }
    },
    removeSelected (id, index) {

      
      
      const userData = this.selected[index]
      this.selected.splice(index, 1)
      this.userInfo.push(userData)

    }
  },

  beforeDestroy () {
    
  },
  destroyed () {
    
  }
}
</script>

<style scoped>
.con-vs-popup .vs-popup {
  width: 700px;
}
.imgpic {
  height: 80px;
  width: 80px;
}
.selected-names {
  background: #e5e4e8;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 5px;
  color: #0078d4;
  font-weight: 600;
  position: relative;
}
.selected-names .close {
  color: red;
  position: absolute;
  top: -12px;
  right: 2px;
  font-size: 25px;
  cursor: pointer;
}
.name-selected {
  white-space: nowrap;
  width: 75px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<style>
.removeCheckbox.vs-con-table .td-check {
  display: none;
}
</style>